var UrlEncode;
UrlEncode = function (str) {
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
};

var url = UrlEncode(window.location.href);
var debug = false;

//var domain ="http://" + window.location.host;
var domain = "https://" + window.location.host + "/cswx";

document.write('<script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.3.0.js"></script>');
document.write('<script type="text/javascript" src="' + domain + '/mobile/server/getwxConfig?url=' + url + '&debug=' + debug + ' "></script>');


var wechat = {};
var a = {};
//自定义微信分享 
wechat.share = function (o) {

    a = o || {},
        t = window.document.title,
        h = location.href,
        d = new Date(),
        s = window.document.getElementsByTagName('img');

    //默认第一张图片
    if (!a.imgUrl && s.length > 0) a.imgUrl = s[0].src;

    wx.ready(function () {
        //分享给朋友
        wx.onMenuShareAppMessage({
            title: a.title || t,
            desc: a.desc || '',
            link: a.link || h,
            imgUrl: a.imgUrl || ""
        });
        //分享到朋友圈
        wx.onMenuShareTimeline({
            title: a.title || t,
            desc: a.desc || '',
            link: a.link || h,
            imgUrl: a.imgUrl || ""
        });
        //分享到QQ
        wx.onMenuShareQQ({
            title: a.title || t,
            desc: a.desc || '',
            link: a.link || h,
            imgUrl: a.imgUrl || ""
        });
        //分享到微博
        wx.onMenuShareWeibo({
            title: a.title || t,
            desc: a.desc || '',
            link: a.link || h,
            imgUrl: a.imgUrl || ""
        });
    });

}

/* 隐藏右上角菜单接口 */
wechat.hideOptionMenu = function () {
    if (typeof wx == "undefined") return false;

    wx.hideOptionMenu();
}

module.exports = wechat;

//     $(function () {

//         //微信JS加载完成
//         wx.ready(function () {
//             //wechat.hideOptionMenu();
//             //wechat.share(option);
//         });

//     });
// window.wechat = wechat;





//////////////////
// WEBPACK FOOTER
// ./static/js/wechat1.js
// module id = fzgl
// module chunks = 1